import styled from 'styled-components';
import React, { FC, useCallback, useRef } from 'react';
import { RowV2, ColV2, BoxV2, EmptyStateV2 } from '@cubeyou-team/hx-react-components';
import uniqid from 'uniqid';
import UsaMapChart from '../UsaMapChart';

const StyledMultipleUsaMapChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 10px;
`;

type MultipleUsaMapChartProps = {
  type: string;
  data: any[];
  metric: string;
  showMoreDetail: boolean;
  onItemClick: (item: any) => void;
  emptyDataMessage: string;
  horizontalLayout?: boolean;
  colors: any;
};

const MultipleUsaMapChart: FC<MultipleUsaMapChartProps> = ({
  type = 'states',
  data,
  metric,
  showMoreDetail,
  onItemClick,
  emptyDataMessage,
  horizontalLayout,
  colors
}) => {
  const chartId = useRef(uniqid());
  const isEmpty = !data || data.length === 0;
  const keys = (!isEmpty && Object.keys(data[0].metrics)) || [];

  const getUsaMapChartData = useCallback(
    (key) => {
      return data.map((d) => {
        return {
          id: d.id,
          insight_type: d.insight_type,
          label: d.label,
          pic: d.pic,
          ...d.metrics[key]
        };
      });
    },
    [data, metric]
  );

  if (isEmpty) {
    return (
      <StyledMultipleUsaMapChartWrapper>
        <BoxV2 minWidth='100%'>
          <EmptyStateV2
            icon='analytics'
            mainText={emptyDataMessage}
            size='large'
          />
        </BoxV2>
      </StyledMultipleUsaMapChartWrapper>
    );
  }
  return (
    <StyledMultipleUsaMapChartWrapper>
      <RowV2
        valign='equal'
        halign={horizontalLayout ? 'left' : 'center'}
        style={{ height: '100%' }}
      >
        {keys.map((key, index) => (
          <ColV2
            span={horizontalLayout && keys.length > 2 ? 4 : 6}
            key={`multiple-usa-map-chart-${chartId.current}-${index}`}
          >
            <BoxV2 style={{ height: '100%' }}>
              <UsaMapChart
                type={type}
                data={getUsaMapChartData(key)}
                metric={metric}
                showMoreDetail={showMoreDetail}
                onItemClick={onItemClick}
                color={colors[key]}
                emptyDataMessage={emptyDataMessage}
              />
            </BoxV2>
          </ColV2>
        ))}
      </RowV2>
    </StyledMultipleUsaMapChartWrapper>
  );
};
export default MultipleUsaMapChart;
